module.exports = __webpack_public_path__ + "img/t3.3eac7baa.jpg";